import client from '@/api/client';
import type { Machine } from '@/types/api';

export const machinesApi = {
  getAll: async (includeInactive = false): Promise<Machine[]> => {
    const response = await client.get<Machine[]>('/machines', {
      params: { includeInactive },
    });
    return response.data;
  },

  create: async (data: {
    code: string;
    name: string;
    description?: string;
    productionMethodId?: string | null;
    sortOrder?: number;
  }): Promise<Machine> => {
    const response = await client.post<Machine>('/machines', data);
    return response.data;
  },

  update: async (
    id: string,
    data: Partial<{
      code: string;
      name: string;
      description: string;
      productionMethodId: string | null;
      sortOrder: number;
      isActive: boolean;
    }>
  ): Promise<Machine> => {
    const response = await client.put<Machine>(`/machines/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/machines/${id}`);
  },
};
